import { createContext, useContext, useEffect, useState } from "react";
import { getCommonSettings } from "./commonApi";
import { blogImageSrc } from "./blogImage";

const FALLBACK_LOGO = "/k-logo.png";
const FALLBACK_CONTACT = {
  phone: process.env.REACT_APP_PHONE || "+91 99999 99999",
  email: process.env.REACT_APP_EMAIL || "support@kademy.com",
  address: process.env.REACT_APP_ADDRESS || "Kademy HQ, India",
};

const SiteSettingsContext = createContext({
  logo: FALLBACK_LOGO,
  ...FALLBACK_CONTACT,
});

export function SiteLogoProvider({ children }) {
  const [settings, setSettings] = useState({
    logo: FALLBACK_LOGO,
    ...FALLBACK_CONTACT,
  });

  useEffect(() => {
    getCommonSettings()
      .then((data) => {
        setSettings({
          logo: data?.logo ? blogImageSrc(data.logo, FALLBACK_LOGO) : FALLBACK_LOGO,
          phone: data?.phone || FALLBACK_CONTACT.phone,
          email: data?.email || FALLBACK_CONTACT.email,
          address: data?.address || FALLBACK_CONTACT.address,
        });
      })
      .catch(() => {});
  }, []);

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteLogo() {
  return useContext(SiteSettingsContext).logo;
}

export function useSiteContact() {
  const { phone, email, address } = useContext(SiteSettingsContext);
  return { phone, email, address };
}
